import { handleApiError, handleApiResponse } from "@/methods/api";
import ApiVerified from "@/services/apiVerified";
import { ApiResponse } from "@/types/global";
import type { EnrolledCourseDisplay } from "@/types/userManagement";

export default class StudentCourseApi extends ApiVerified {
  async getEnrolledCourses(): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.get<Array<EnrolledCourseDisplay>>(
        `student/get-enrolled-courses`,
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }
}
